import React from 'react';
import { FOUNDER } from '../data/dgpt';

/** Real founder photo when configured; otherwise a neutral initials mark (never a generated face). */
export function FounderAvatar() {
  if (FOUNDER.photo) {
    return <img src={FOUNDER.photo} alt={`${FOUNDER.name}, ${FOUNDER.role}`} width={72} height={72} loading="lazy" className="h-[72px] w-[72px] shrink-0 rounded-2xl object-cover" data-id="element-561" data-mp="10u76ly1n4b92" />;
  }
  const initials = FOUNDER.name.split(' ').filter((_, index, parts) => index === 0 || index === parts.length - 1).map(part => part[0]).join('');
  return <span aria-hidden="true" className="flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-2xl bg-[#F1EFFA] text-xl font-semibold text-lime" data-id="element-562" data-mp="1jj4388kiffug">
      {initials}
    </span>;
}